// TODO: Move File
/** Representation of a Country */
export interface Country {
  readonly isoId: string;
  /** Name of the Country */
  name: string;
  /** Two-letter ISO code  */
  isoCodeTwo: string;
}
export interface CountryDto {
  readonly isoNum: string;
  /** Name of the Country */
  name: string;
  /** Two-letter ISO code  */
  iso2: string;
}
export function parseToCountry (value: CountryDto): Country {
  return {
    isoId: value.isoNum,
    name: value.name,
    isoCodeTwo: value.iso2
  };
}
export function parseToCountryDto (value: Country): CountryDto {
  return {
    iso2: value.isoCodeTwo,
    name: value.name,
    isoNum: value.isoId
  };
}
